import { render, staticRenderFns } from "./EditSection.vue?vue&type=template&id=63db09b2&scoped=true"
import script from "./EditSection.vue?vue&type=script&lang=js"
export * from "./EditSection.vue?vue&type=script&lang=js"
import style0 from "./EditSection.vue?vue&type=style&index=0&id=63db09b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63db09b2",
  null
  
)

export default component.exports